import { Container, Stack, Box, Heading, Text, Button } from "@chakra-ui/react";
import { motion } from "framer-motion";
import { Link as Reachlink } from "@reach/router";
import Dropzone from "./Dropzone";

const MotionBox = motion(Box);

function Home({ onDrop }) {
  return (
    <>
      <Container maxW={"5xl"}>
        <Stack
          spacing={{ base: 8, md: 10 }}
          py={{ base: 28, md: 40 }}
          align={"center"}
          direction={{ base: "column", md: "row" }}
        >
          <Stack flex={1} spacing={{ base: 5, md: 10 }} align={{ base: "center", md: "start" }}>
            <Heading lineHeight={1.1} fontWeight={600} fontSize={{ base: "5xl", lg: "6xl" }}>
              <Text
                as={"span"}
                position={"relative"}
                _after={{
                  content: "''",
                  width: "full",
                  height: "30%",
                  position: "absolute",
                  bottom: 1,
                  left: 0,
                  bg: "red.400",
                  zIndex: -1,
                }}
              >
                Discover your
              </Text>
              <br />
              <Text as={"span"} color={"red.400"}>
                YT-History
              </Text>
            </Heading>

            <Text
              color={"gray.500"}
              w={{ base: "100%", sm: "70%", md: "100%" }}
              textAlign="justify"
            >
              Have you ever wondered how much time you spend on YouTube? Or how many videos you've
              watched over the years? Or maybe which channel you've watched the most? This site will
              answer all these questions and much more!
            </Text>
            <Stack
              spacing={{ base: 4, sm: 6 }}
              direction={{ base: "column", sm: "row" }}
              w={{ base: "100%", sm: "fit-content" }}
            >
              <Button
                rounded={"2xl"}
                size={"lg"}
                fontWeight={"normal"}
                px={6}
                colorScheme={"red"}
                bg={"red.400"}
                _hover={{ bg: "red.500" }}
              >
                Demo
              </Button>
              <Button
                as={Reachlink}
                to="guide"
                rounded={"2xl"}
                size={"lg"}
                fontWeight={"normal"}
                px={6}
              >
                Get Started
              </Button>
            </Stack>
          </Stack>

          <MotionBox
            position={"relative"}
            rounded={"2xl"}
            width={{ base: "90vw", sm: "400px" }}
            minWidth={{ base: "100%", sm: "auto" }}
            boxShadow={"2xl"}
            overflow={"hidden"}
            drag
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            dragConstraints={{
              top: -50,
              left: -50,
              right: 50,
              bottom: 50,
            }}
          >
            <Dropzone onDrop={onDrop} />
          </MotionBox>
        </Stack>
      </Container>
    </>
  );
}

export default Home;
